<template>

  <el-dialog
    title="配送管理"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
  <el-form size="small" ref="form" :model="form" label-width="150px" >
      
      <el-form-item label="开启商家配送：">
        <el-switch
          v-model="form.status"
          active-text="开启"
          inactive-text="关闭">
        </el-switch>
      </el-form-item>
      <el-form-item label="配送范围：" >
        <el-input v-model="form.distance" min="0"  type="number" class="max-w460">
          <template slot="append">
            <el-button>km</el-button>
          </template>
        </el-input>
        <div class="tips">
          <p>店铺设置中的定位为中心，设置配送范围。顾客的地址在配送范围内则可以配送。</p>
        </div>
      </el-form-item>
      <el-form-item label="配送费：" >
        <el-input v-model="form.price" min="0" type="number" class="max-w460">
          <template slot="append">
            <el-button>元</el-button>
          </template>
        </el-input>
      </el-form-item>
      <!--提交-->
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitApi" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import DistributionApi from '@/api/distribution.js';
export default {
  components: {
  },
  inject: ['reload'],
  data() {
    return {
      form:{
        status:false,
        price:0,
        distance:0,
      },
      /*是否加载完成*/
      
    };
  },
  props: ["open_list", "store_id"],
  created() {
    this.dialogVisible = this.open_list;
    /*获取列表*/
    this.getData();
  },
  methods: {
    submitApi(){
      let self = this;
      let param = self.form;
      DistributionApi.storeSetting({
        store_id:self.store_id,
        status:param.status?1:0,
        price:param.price,
        distance:param.distance,
      }, true)
        .then(data => {
          self.$message({
                message: '恭喜你，设置成功',
                type: 'success'
              });
          self.dialogFormVisible()
        })
        .catch(error => {});
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = {};
      Params.store_id = self.store_id;
      DistributionApi.getData(Params, true)
        .then(res => {
          self.loading = false;
          if(res.data.data){
            self.form = res.data.data
          }
        })
        .catch(error => {});
    },
     /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/distribution/store/handle.vue